module.exports = __webpack_public_path__ + "img/tr.48389308.png";